<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Umsätze</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createsale')">Umsatz anlegen</b-button>
                </b-col>
                <b-col>
                    <StoreSaleCreationWithTemplate @refreshStoreSales ="refresh"></StoreSaleCreationWithTemplate>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="sales != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="sales" :fields="fields">
                        <template slot="amount" slot-scope="row">
                            {{row.item.amount/100}}
                            
                        </template>
                        <template slot="planned" slot-scope="row">
                            {{getSalePlannedText(row.item.planned)}}
                            
                        </template>
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    <b-modal ref="modal-createsale"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsatz erstellen" @cancel="hideModal('modal-createsale')" @ok="createStoreSale" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Umsatz" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSale.amount" step="0.01" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Währung" label-for="css2">
                    <b-form-select id = "css2" v-model="storeSale.currency">
                        <option v-bind:key ="1" v-bind:value="'EUR'">
                            EUR
                        </option>
                        <option v-bind:key ="2" v-bind:value="'USD'">
                            USD
                        </option>
                        <option v-bind:key ="3" v-bind:value="'GBP'">
                            GBP
                        </option>
                        <option v-bind:key ="4" v-bind:value="'CHF'">
                            CHF
                        </option>
                        <option v-bind:key ="5" v-bind:value="'CZK'">
                            CZK
                        </option>
                        <option v-bind:key ="6" v-bind:value="'JPY'">
                            JPY
                        </option>
                        <option v-bind:key ="7" v-bind:value="'CNY'">
                            CNY
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="css3">
                    <b-form-input id="css3" v-model="storeSale.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="css4">
                    <b-form-input id="css4" v-model="storeSale.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="css5">
                    <b-form-input id="css5" v-model="storeSale.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="css6">
                    <b-form-input id="css6" v-model="storeSale.toTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Soll/Ist" label-for="css7">
                    <b-form-select id = "css7" v-model="storeSale.planned">
                        <option v-bind:key ="1" v-bind:value="true">
                            Soll
                        </option>
                        <option v-bind:key ="2" v-bind:value="false">
                            Ist
                        </option>
                        
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Stückzahl" label-for="css9">
                    <b-form-input id="css9" v-model.number="storeSale.itemCount" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Gästezahl" label-for="css10">
                    <b-form-input id="css10" v-model.number="storeSale.guestCount" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Beschreibung" label-for="css11">
                    <b-form-input id="css11" v-model="storeSale.description" type="text"></b-form-input>
                </b-form-group>
                


            </div>
           
            <b-row v-if="saleerror">
                Fehler beim Bearbeiten des Umsatzes.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editsale"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsatz bearbeiten" @cancel="hideModal('modal-editsale')" @ok="editStoreSale" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Umsatz" label-for="uss1" >
                    <b-form-input min="0" id="uss1" v-model.number="storeSale.amount" step="0.01" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Währung" label-for="uss2">
                    <b-form-select id = "uss2" v-model="storeSale.currency">
                        <option v-bind:key ="1" v-bind:value="'EUR'">
                            EUR
                        </option>
                        <option v-bind:key ="2" v-bind:value="'USD'">
                            USD
                        </option>
                        <option v-bind:key ="3" v-bind:value="'GBP'">
                            GBP
                        </option>
                        <option v-bind:key ="4" v-bind:value="'CHF'">
                            CHF
                        </option>
                        <option v-bind:key ="5" v-bind:value="'CZK'">
                            CZK
                        </option>
                        <option v-bind:key ="6" v-bind:value="'JPY'">
                            JPY
                        </option>
                        <option v-bind:key ="7" v-bind:value="'CNY'">
                            CNY
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="uss3">
                    <b-form-input id="uss3" v-model="storeSale.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="uss4">
                    <b-form-input id="uss4" v-model="storeSale.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="uss5">
                    <b-form-input id="uss5" v-model="storeSale.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="uss6">
                    <b-form-input id="uss6" v-model="storeSale.toTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Soll/Ist" label-for="uss6">
                    <b-form-select id = "uss6" v-model="storeSale.planned">
                        <option v-bind:key ="1" v-bind:value="true">
                            Soll
                        </option>
                        <option v-bind:key ="2" v-bind:value="false">
                            Ist
                        </option>
                        
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Stückzahl" label-for="uss7">
                    <b-form-input id="uss7" v-model.number="storeSale.itemCount" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Gästezahl" label-for="uss8">
                    <b-form-input id="uss8" v-model.number="storeSale.guestCount" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Beschreibung" label-for="uss9">
                    <b-form-input id="uss9" v-model="storeSale.description" type="text"></b-form-input>
                </b-form-group>
                


            </div>
           
            <b-row v-if="saleerror">
                Fehler beim Bearbeiten des Umsatzes.
            </b-row>
        </b-container>
    </b-modal>




   <b-modal ref="modal-viewsale"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsatz Detail" @cancel="hideModal('modal-viewsale')" @ok="hideModal('modal-viewsale')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>   
                <b-tab title="Sales & Infos">
                    <div v-if="saleId != undefined && saleMap[saleId] != undefined">
                        
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].to}}
                            </b-col>
                        </b-row>
                       
                        <b-row>
                            <b-col class="md-2">
                                <b>Umsatz:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].amount/100}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Währung:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].currency}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Soll/Ist:</b>
                            </b-col>
                            <b-col>
                                {{getSalePlannedText(saleMap[saleId].planned)}}
                            </b-col>
                           
                        </b-row>
                        <b-row>
                            
                            <b-col class="md-2">
                                <b>Stückzahl:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].itemCount}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gästezahl:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].guestCount}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Beschreibung:</b>
                            </b-col>
                            <b-col>
                                {{saleMap[saleId].description}}
                            </b-col>
                            
                        </b-row>
                       
                        
                    </div>
                </b-tab>
                
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>
    <b-modal ref="modal-deletesale"  no-close-on-backdrop no-close-on-esc centered title="Umsatz löschen" @cancel="hideModal('modal-deletesale')" @ok="deleteSale" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie den Umsatz löschen wollen?</p>
            </b-row>
            <b-row v-if="saleerror" class="my-1">
                Fehler beim Löschen des Umsatzes.
            </b-row>
        </b-container>
    </b-modal>
    
  </div> 

</template>

<script>
import StoreSaleCreationWithTemplate from './StoreSaleCreationWithTemplate.vue';
export default {
  name: 'storesalesoverview',
  data () {
    return {
      sales: [],
      saleMap:{},
      fields: [{key:"from", thClass: 'documentsTh', tdClass: 'documentsTd', label:"Von"}, {key:"to", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Bis"}, {key:"amount", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Umsatz"}, {key:"currency", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Währung"}, {key:"planned", thClass: 'documentsTh', tdClass: 'documentsTd',label:"Soll/Ist"}, {key:"actions", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      saleId:"",
      currentSaleRow: undefined,
      storeSale: {
          id: null,
          amount: 0.00,
          currency: null,
          planned: true,
          fromDate: null,
          fromTime: null,
          toDate: null,
          toTime: null,
          itemCount: 0,
          guestCount: 0,
          description: "",
          
      },
      saleerror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        this.loadStoreSales()
        .then(response => {
            view.updateStoreSales(response.data);
           
        }).catch(function (error) {
            console.log(error)
        })

    },
    openEditModal: function(row){
        this.currentSaleRow = row;
        this.saleId = row.item.id;
        this.storeSale.id = row.item.id;
        this.storeSale.amount = row.item.amount/100;
        this.storeSale.currency = row.item.currency;
        this.storeSale.planned = row.item.planned;
        this.storeSale.itemCount = row.item.itemCount;
        this.storeSale.guestCount = row.item.guestCount;
        this.storeSale.description = row.item.description;
        this.storeSale.fromDate = this.$helpers.getMomentFromStringUTC(row.item.from).format("YYYY-MM-DD");
        this.storeSale.fromTime = this.$helpers.getMomentFromStringUTC(row.item.from).format("HH:mm");
        this.storeSale.toDate = this.$helpers.getMomentFromStringUTC(row.item.to).format("YYYY-MM-DD");
        this.storeSale.toTime = this.$helpers.getMomentFromStringUTC(row.item.to).format("HH:mm");
        
        
        this.showModal('modal-editsale');
    },
    getSalePlannedText(planned){
        if(planned){
            return "Soll";
        } else {
            return "Ist";
        }
    },
    createStoreSale: function(evt){
        evt.preventDefault();
        this.saleerror=false;
        let view = this;
        let url = '/api/sec/storesales';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');
        
        let payload = {
          
          amount: Math.floor(this.storeSale.amount*100),
          currency: this.storeSale.currency,
          from: this.$helpers.convertDateTimeString(this.storeSale.fromDate, this.storeSale.fromTime),
          to: this.$helpers.convertDateTimeString(this.storeSale.toDate, this.storeSale.toTime),
          planned: this.storeSale.planned,
          itemCount: this.storeSale.itemCount,
          guestCount: this.storeSale.guestCount,
          description: this.storeSale.description,
        }

        

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            view.saleMap[response.data.data.id] = response.data.data;
            view.saleId = response.data.data.id;
            view.sales.push(response.data.data);
          
            
            view.hideModal('modal-createsale');
            
            
        }).catch(function (error) {
            view.saleerror=true;
            console.log(error)
        })

    },
    editStoreSale: function(evt){
        evt.preventDefault();
        this.saleerror=false;
        let view = this;
        let url = '/api/sec/storesales';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');
        
        let payload = {
          id: this.saleId,
          updateFields:["amount", "currency", "from", "to", "planned", "itemCount", "description"],
          amount: Math.floor(this.storeSale.amount*100),
          currency: this.storeSale.currency,
          from: this.$helpers.convertDateTimeString(this.storeSale.fromDate, this.storeSale.fromTime),
          to: this.$helpers.convertDateTimeString(this.storeSale.toDate, this.storeSale.toTime),
          planned: this.storeSale.planned,
          itemCount: this.storeSale.itemCount,
          guestCount: this.storeSale.guestCount,
          description: this.storeSale.description,
        }

        

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            view.currentSaleRow.item.amount = payload.amount;
            view.currentSaleRow.item.currency = payload.currency;
            view.currentSaleRow.item.from = payload.from;
            view.currentSaleRow.item.to = payload.to;
            view.currentSaleRow.item.planned = payload.planned;
            view.currentSaleRow.item.itemCount = payload.itemCount;
            view.currentSaleRow.item.guestCount = payload.guestCount;
            view.currentSaleRow.item.description = payload.description
           
            let saleMapItem = view.saleMap[view.saleId];

            if(saleMapItem != undefined){
                for (let property in payload) {
                    if (payload.hasOwnProperty(property) && saleMapItem.hasOwnProperty(property)) {
                        saleMapItem[property] = payload[property];
                    }
                }
            }
          
            
            view.hideModal('modal-editsale');
            
            
        }).catch(function (error) {
            view.saleerror=true;
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentSaleRow = row;
       
        this.saleId = row.item.id;
        this.showModal('modal-deletesale');
    },
    deleteSale: function(evt){
        evt.preventDefault();
        this.spoterror=false;
        let view = this;
        let url = '/api/sec/storesales';
        
        url = this.$helpers.appendParam("id", this.saleId, url, '/api/sec/storesales');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.sales.findIndex(sale => sale.id === view.saleId) // find the spotsinessunit index 
            if (~index) {
                view.sales.splice(index, 1);
            }
            delete view.saleMap[view.saleId];     
            view.hideModal('modal-deletesale');
        }).catch(function (error) {
            view.saleerror=true;
            console.log(error)
        })

    },
   
    openViewModal: function(row){
        this.currentSaleRow = row;
        this.saleId = row.item.id;
        
        this.showModal('modal-viewsale');
    },
    
    loadStoreSales : function() {
      
      let url = '/api/sec/storesales';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    
    updateStoreSales: function(data){
        
        let tsaleMap = {};
        let tsales = [];
        for (let i = 0; i < data.length; i++) {
            tsaleMap[data[i].id] =data[i];
            tsales.push(data[i]);
        }
        this.sales = tsales;
        this.saleMap = tsaleMap;
    },
    hideModalWithoutReset (ref) {
        this.saleerror=false;
        this.$refs[ref].hide();
    },
    resetStoreSaleValues(){
        this.storeSale ={
          id: null,
          amount: 0.00,
          currency: null,
          planned: true,
          fromDate: null,
          fromTime: null,
          toDate: null,
          toTime: null,
          itemCount: 0,
          guestCount: 0,
          description: "",
          
      }
    },
    hideModal (ref) {
       
        this.resetStoreSaleValues();

        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
      StoreSaleCreationWithTemplate,
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
